import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ExchangeActions } from '../../../../state-management/exchange/exchange.action';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { StockCardsComponent } from '../../stock-cards.component';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { StocksExchangeCheckoutAction } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { debounceTime, filter, first, map, tap } from 'rxjs/operators';
import { environment } from '@hub-workspace/apps/stock/src/environments/environment';


@AutoUnsubscribe()
@Component({
    selector: 'tracking-card',
    templateUrl: './tracking-card.component.html',
})
export class TrackingCardComponent extends StockCardsComponent implements OnInit, OnDestroy {

    @Input() symbol: string;
    @Input() isStrategy: boolean = false;
    @Input() gainPrice: number = 0;
    @Input() lossPrice: number = 0;
    @Input() amount: number = 1;
    @Input() purchase: boolean;
    @Input() closeTime: string = ''
    @Input() isToroZero: boolean = false;

    public tooltipLucro: string = `<div>
            <div class='pop-title'>Lucro</div>
            <div class='pop-content'>
                O investimento encerra quando alcançar o lucro planejado. O valor do lucro pode variar de acordo com as condições do mercado.
            </div>
        </div>`;

    public tooltipPrejuizo: string = `<div>
            <div class='pop-title'>Prejuizo</div>
            <div class='pop-content'>
                O investimento encerra quando alcançar o prejuízo planejado. O valor do prejuízo pode variar de acordo com as condições do mercado.
            </div>
        </div>`;
    
    public unitPrice: number = 0;
    public companyName: string = '';
    public logo: string = '';
    public isFuture: boolean = false;
    public isOption: boolean = false;
    public isExpired: boolean = false;
    public isDayTrade: boolean = false;
    public isSummerTime: boolean;
    
    private quote: any = null;
    private instrument: any = null;

    private quoteSubscription: Subscription;
    private instrumentSubscription: Subscription;

    constructor(
        protected router: Router,
        protected dialogsServices: DialogsService,
        protected store: Store<AppState>,
        protected changeDetectorRef: ChangeDetectorRef,
        private datePipe: DatePipe,
    ) {
        super(router, dialogsServices, store, changeDetectorRef);
    }

    ngOnInit() {

        // Recupera os dados de cotação
        this.quoteSubscription = this.store.select(s => s.stocksExchange.stocksMarket.quote).pipe(
            filter(f => f[this.symbol]),
            map(m => m[this.symbol])
        )
            .subscribe(data => {
                this.quote = data;
                const price = this.quote.PriceLastTrade || this.quote.OpeningPrice || this.quote.ClosingPricePreviousDay;
                if (price != null)
                    this.unitPrice = price
            });

        // Recupera os dados de instrumento
        this.instrumentSubscription = combineLatest([
            this.store.select(s => s.stocksExchange.stocksMarket.instruments),
            this.store.select(s => s.exchange.tradingTime)
        ]).pipe(
            filter(([instruments, tradingTime]) => !!instruments[this.symbol] && !!tradingTime),
            debounceTime(300),
            first(),
            tap(([instruments, tradingTime]) => {
                const limitDayTradeStock = this.normalizeDate((tradingTime.limitDayTradeStock as string));
                const limitDayTradeFuture = this.normalizeDate((tradingTime.limitDayTradeFuture as string));
                
                const instrument = { ...instruments[this.symbol] };

                this.instrument = instrument;
                const price = this.instrument.priceLastTrade || this.instrument.openingPrice || this.instrument.closingPricePreviousDay;
                if (price != null)
                    this.unitPrice = price;
                this.isFuture = this.instrument.typeMarket === OrderMarketTypeEnum.Future;
                this.isOption = this.instrument.typeMarket === OrderMarketTypeEnum.Option;
                this.companyName = instrument.descriptionStock;
                this.logo = instrument.logo.content;
                this.isDayTrade = this.stockDetails && this.stockDetails.isDayTrade ? this.stockDetails.isDayTrade : false;
                this.isSummerTime = this.getTimeZoneHour() === 2;

                this.closeTime = this.datePipe.transform(
                this.isFuture ? limitDayTradeFuture : limitDayTradeStock,
                'HH:mm'
                );
            })
        ).subscribe();

        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbol });
        this.store.dispatch({ type: ExchangeActions.getTradingTime });
    }

    ngAfterViewInit() {
        this.isExpired = this.stockDetails.expirationDate ? new Date(this.stockDetails.expirationDate) < new Date() : false;
    }

    /**
     * Recupera o fuso horário do usuário;
     */
    getTimeZoneHour() {
        const date = new Date();
        const timeZone = date.getTimezoneOffset() / 60;
        return Math.abs(timeZone);
    }

    /**
     * Método para ajustar a string do tradingHour que está vindo da webapi
     * GAMBIARRA!! REMOVER QUANDO ARRUMAREM NA API.
     */
    normalizeDate(date: string) {
        const today = new Date();
        const todayIso = today.toISOString().split("T");
        const dateISO = date.split("T");
        return `${todayIso[0]}T${dateISO[1]}`;
    }

    createPlan(){
        let message = `Quando você cria um plano de lucro e prejuízo, o valor que você precisa para investir pode ser reduzido. A diferença será transferida para sua conta corrente da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }.`;
        this.openModalConfirm("Você quer criar um planejamento para este investimento?", message, "Criar", "Voltar").subscribe(result => {
            if (result) {
                let item = new StockCheckoutType();
                item.symbol = this.symbol;
                item.amount = this.amount;
                item.creatingPlanning = true;
                item.purchase = this.purchase;
                this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item});
                this.router.navigate(['/checkout/planejado']);
            }
        });
    }

    /** Nescessário para o AUTOUNSUBSCRIBE */
    ngOnDestroy(){
        this.store.dispatch({ type: StocksMarketAction.unsubscribeQuotes, payload: [this.symbol] });
    };

}